<template>
    <v-container>
        <v-card class="dt-border pad-10" flat>
            <v-container>
                <v-row class="pa-5 mb-5">
                    <div>
                        <h2>Audit Logs</h2>
                        <p>Track all recent activities performed in your organization</p>
                    </div>
                </v-row>
                <v-row class="pl-5">
                    <div>
                        <span v-if="details.total != 0 && this.loading == false" class="dt-orange white--text pa-2 rounded">Total Audit logs {{details[1]}}</span>
                    </div>
                    <v-spacer></v-spacer>
                    <dtunes-pagination
                        @reload="reload"
                        @nextPage="pageChangeHandle('next')"
                        @previousPage="pageChangeHandle('previous')"
                        :rows="rows"
                        :limit="limit"
                        :page="page"
                        :totalPage="totalPage"
                    />
                </v-row>
                <br><br>
                <dtunes-loader :loading="loading"></dtunes-loader>
                <audit-table :details="details"></audit-table>
                <dtunes-empty v-if="details.total == 0 && this.loading == false">
                    <template v-slot:title>
                        No  Audit logs yet
                    </template>
                    <template v-slot:sub-title>
                        <!-- Click on the create New Store button to create a Store -->
                    </template> 
                </dtunes-empty>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
// ============= IMPORT COMPONENTS ===========
import DtunesLoader from "@/components/dtunes-loader.vue"
import DtunesEmpty from "@/components/dtunes-empty.vue"
import DtunesPagination from "@/components/dtunes-pagination.vue"
import AuditTable from "../components/audit-table.vue"

// ============= IMPORT SERVICES ===========
import { AdminService } from "@/services";

export default {
    components:{
        DtunesLoader,
        DtunesEmpty,
        DtunesPagination,
        AuditTable
    },
    data:() =>({
        loading:false,
        details:{},
        rows:[20,50,100],
        totalPage:0,
        limit:20,
        page:1,
    }),
    mounted(){
        this.getAudits()
    },
    methods:{
        async getAudits(){
            try {
                this.loading = true;
                const data = await AdminService.getAudits({
                    page : this.page,
                    limit : this.limit
                });
                this.loading = false;
                this.details = data;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
            this.totalPage = Math.ceil(this.details[1] / this.limit)
        },
        async reload(value){
            if(value){
              this.limit = value
            }
            await this.getAudits();
        },
        async pageChangeHandle(value) {
          switch (value) {
            case 'next':
              this.page += 1
              break
            case 'previous':
              this.page -= 1
              break
            default:
              this.page = value
          }
          this.getAudits();
        }
    }

}
</script>